import React, { useEffect } from 'react';

// assets

// services

// props

// components
import { DefaultButton, Panel, PanelType, PrimaryButton, Stack, TextField } from '@fluentui/react';
import { FormDataProps } from '../../props';
import GeneralService from '../../../../../../../../services/general';
import ValidationService from '../../../../../../../../services/validation';
import { IOutcomeInvoiceItemResourceShortProps } from '../../../../../../../../props/finance/outcomes/item';
import Details from '../../../../../../../typography/details';


type InvoiceItemSubformProps = {
    disabled?: boolean;
    data: Partial<FormDataProps>;
    item?: IOutcomeInvoiceItemResourceShortProps;
    onDismissed(item?: IOutcomeInvoiceItemResourceShortProps): void;
}

const InvoiceItemSubform: React.FC<InvoiceItemSubformProps> = (props: InvoiceItemSubformProps) => {
    const [data, setData] = React.useState<IOutcomeInvoiceItemResourceShortProps>(props.item || {
        id: GeneralService.guid(),
        name: "",
        notes: "",
        price: "",
        totalPrice: "",
        quantityAmount: "1",
        quantityUnit: "unit",
        orderNumber: 1
    });
    const [error, setError] = React.useState<any>({});

    useEffect(() => {
    }, []);

    const isSubmitButtonDisabled = () => {
        if ((data.name || "").trim() === "" || (data.price || "").trim() === "" || (data.quantityAmount || "").trim() === "" || (data.quantityUnit || "").trim() === "") {
            return true;
        } else if (error.price || error.quantityAmount || error.quantityUnit || error.name || error.notes) {
            return true;
        }

        return false;
    }

    const calculateTotalPrice = (_data: IOutcomeInvoiceItemResourceShortProps) => {
        let totalPrice = 0;

        if (!isNaN(Number(_data.price)) && !isNaN(Number(_data.quantityAmount))) {
            totalPrice = Number(_data.price) * Number(_data.quantityAmount);
        }

        return totalPrice.toFixed(2);
    }

    return <Panel headerText={props.item ? "Update Invoice Item" : "Add Invoice Item"}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed()}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }} horizontalAlign={'space-between'} verticalAlign='center'>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <PrimaryButton text={"Submit"} disabled={isSubmitButtonDisabled()} onClick={() => {
                        props.onDismissed({
                            id: data.id || GeneralService.guid(),
                            name: data.name || "",
                            notes: data.notes || "",
                            price: data.price || "0",
                            totalPrice: data.totalPrice || "0",
                            quantityAmount: data.quantityAmount || "0",
                            quantityUnit: data.quantityUnit || "0",
                            orderNumber: data.orderNumber
                        });
                    }} />
                    <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed() }} />
                </Stack>
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }}>
            <TextField label={"Name"}
                required={true}
                value={data.name || ""}
                onChange={(evt, value) => {
                    data.name = value || "";

                    const validation = ValidationService.combination(value, ['required', 'limit'], { maxChars: 100 });
                    error.name = validation.message;

                    setData({ ...data });
                    setError({ ...error });
                }}
                errorMessage={error.name} />
            <TextField label={"Notes"}
                required={false}
                autoAdjustHeight
                resizable={false}
                rows={5}
                multiline
                value={data.notes || ""}
                onChange={(evt, value) => {
                    data.notes = value || "";

                    const validation = ValidationService.combination(value, ['limit'], { maxChars: 1000 });
                    error.notes = validation.message;

                    setData({ ...data });
                    setError({ ...error });
                }}
                errorMessage={error.notes} />
            <TextField label={"Price per quantity"}
                prefix='Rp'
                required={true}
                value={(data.price === undefined ? "" : data.price) + ""}
                onChange={(evt, value) => {
                    if ((value || "").trim() === "" || !isNaN(Number(value))) {
                        data.price = value !== "" ? (value || "") : "";

                        const validation = ValidationService.combination(value, ['required', 'limit', 'number'], { maxChars: 20 });
                        error.amount = validation.message;

                        data.totalPrice = calculateTotalPrice(data);

                        setData({ ...data });
                        setError({ ...error });
                    }
                }}
                errorMessage={error.price} />
            <Stack horizontal tokens={{ childrenGap: 10 }}>
                <TextField label={"Quantity amount"}
                    required={true}
                    value={(data.quantityAmount === undefined ? "" : data.quantityAmount) + ""}
                    onChange={(evt, value) => {
                        if ((value || "").trim() === "" || !isNaN(Number(value))) {
                            data.quantityAmount = value !== "" ? (value || "") : "";

                            const validation = ValidationService.combination(value, ['required', 'limit', 'number'], { maxChars: 20 });
                            error.quantityAmount = validation.message;
                            
                            data.totalPrice = calculateTotalPrice(data);

                            setData({ ...data });
                            setError({ ...error });
                        }
                    }}
                    errorMessage={error.quantityAmount}
                    styles={{root: {width: '100%'}}} />
                <TextField label={"Quantity unit"}
                    required={true}
                    value={data.quantityUnit || ""}
                    onChange={(evt, value) => {
                        data.quantityUnit = value || "";

                        const validation = ValidationService.combination(value, ['required', 'limit'], { maxChars: 100 });
                        error.quantityUnit = validation.message;

                        setData({ ...data });
                        setError({ ...error });
                    }}
                    errorMessage={error.quantityUnit}
                    styles={{root: {width: '250px'}}} />
            </Stack>
            <Stack className={'divider'} />
            <Details title={'Total price'} text={'Rp. ' + GeneralService.getNumberWithSeparator(data.totalPrice)} />
        </Stack>
    </Panel>
};

export default InvoiceItemSubform;
